module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-8"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-head1"
  }, [_vm._v("Picture Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("In the book")])]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("1.")]), _vm._v(" Wellcome Collection. CC BY")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("2.")]), _vm._v(" Wellcome Collection. CC BY")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("3.")]), _vm._v(" Wellcome Collection. CC BY")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("4.")]), _vm._v(" John Barker [Public domain]")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("5.")]), _vm._v(" Public Domain, from the British Library’s collections, 2013")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("6.")]), _vm._v(" Abraham Storck [Public domain]")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("7.")]), _vm._v(" Sylvanus Urban [Public domain]")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("8.")]), _vm._v(" Public Domain, from the British Library’s collections, 2013")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("9.")]), _vm._v(" tyburntree.wordpress.com [Public domain]")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("10.")]), _vm._v(" Ralph Gardiner [Public domain]")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("11.")]), _vm._v(" Wellcome Collection. CC BY")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("12.")]), _vm._v(" en:User:Raymond Palmer [Public domain]")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("13.")]), _vm._v(" Jan Luyken [Public domain]")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("14.")]), _vm._v(" Wellcome Collection. CC BY")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("15.")]), _vm._v(" Manchester Art Gallery [Public domain]")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("16.")]), _vm._v(" Wellcome Collection. CC BY")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("17.")]), _vm._v(" Wellcome Collection. CC BY")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("18.")]), _vm._v(" Attributed to Henri Beaubrun (1603-1677) [Public domain]")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("19.")]), _vm._v(" Wellcome Collection. CC BY")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("20.")]), _vm._v(" Wellcome Collection. CC BY")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("21.")]), _vm._v(" Susan Doran [Public domain]")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("22.")]), _vm._v(" Public Domain, from the British Library’s collections, 2013")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-9"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Picture Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("23.")]), _vm._v(" Public Domain, from the British Library’s collections, 2013")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("24.")]), _vm._v(" Wellcome Collection. CC BY")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("25.")]), _vm._v(" Wellcome Collection. CC BY")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("26.")]), _vm._v(" Author’s private collection")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("27.")]), _vm._v(" Author’s private collection")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("28.")]), _vm._v(" Author’s private collection")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("29.")]), _vm._v(" Author’s private collection")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("30.")]), _vm._v(" Author’s private collection")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("31.")]), _vm._v(" Author’s private collection")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("32.")]), _vm._v(" Author’s private collection")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("33.")]), _vm._v(" Author’s private collection")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("34.")]), _vm._v(" Jacob Truedson Demitz for Ristesson History [Public domain]")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("35.")]), _vm._v(" The Portable Antiquities Scheme/The Trustees of the British Museum [CC BY-SA 2.0 (https://creativecommons.org/licenses/ by-sa/2.0)]")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("On the cover")])]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("1.")]), _vm._v(" (Townspeople fleeing to the countryside to escape the plague in England, 1630. Hand-coloured woodcut.) North Wind Picture Archives / Alamy Stock Photo")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("2.")]), _vm._v(" (The beheading of Charles I outside the Banqueting Hall of Whitehall in 1649. Engraving with etching.) Wellcome Collection. CC BY")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("3.")]), _vm._v(" (Surgeons performing an operation on a woman’s breast in the seventeenth century.) Wellcome Collection. CC BY")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter headers")])]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "hang"
  }, [_vm._v("1.")]), _vm._v(" (Skull on a book) Public Domain, from the British Library’s collections, 2013")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-471c7582","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/007_Acknowledgements.vue
// module id = 75
// module chunks = 0